// Sisi kanan <-> param `vs` di URL. Sengaja nol import biar bisa dijalanin node.

export const RIGHT_PERIOD_KINDS = [
  { value: 'same', label: 'Same as range' },
  { value: 'previous', label: 'Previous period' },
  { value: 'lastWeek', label: 'Last week' },
  { value: 'lastMonth', label: 'Last month' },
  { value: 'custom', label: 'Custom dates' },
];

// batas keras link; batas tombol Add dihitung dari lebar layar
export const MAX_COMPARISONS = 9;

const RELATIVE_KINDS = ['same', 'previous', 'lastWeek', 'lastMonth'];
const DIGITS = /^\d{1,11}$/;

function isCustom(period) {
  return period && period.kind === 'custom'
    && Number.isFinite(Number(period.startMs))
    && Number.isFinite(Number(period.endMs))
    && Number(period.startMs) < Number(period.endMs);
}

export function encodeRight(right) {
  if (!right) return '';
  const period = right.period || {};
  const massId = right.massId === null || right.massId === undefined || right.massId === '' ? '' : String(right.massId);
  if (period.kind === 'custom') {
    if (!isCustom(period)) return '';
    const start = Math.floor(Number(period.startMs) / 1000);
    const end = Math.floor(Number(period.endMs) / 1000);
    return `${massId}@custom-${start}-${end}`;
  }
  const kind = RELATIVE_KINDS.includes(period.kind) ? period.kind : 'same';
  // Kapal sama + periode sama = nggak ada yang dibandingin.
  if (kind === 'same' && massId === '') return '';
  return kind === 'same' ? massId : `${massId}@${kind}`;
}

function parseEntry(entry) {
  const text = (entry || '').trim();
  if (!text) return null;
  const at = text.indexOf('@');
  const massText = at === -1 ? text : text.slice(0, at);
  const periodText = at === -1 ? 'same' : text.slice(at + 1);
  if (massText !== '' && !DIGITS.test(massText)) return null;
  const massId = massText === '' ? null : Number(massText);

  if (periodText.startsWith('custom-')) {
    const parts = periodText.split('-');
    if (parts.length !== 3) return null;
    const [, startText, endText] = parts;
    if (!DIGITS.test(startText) || !DIGITS.test(endText)) return null;
    const startMs = Number(startText) * 1000;
    const endMs = Number(endText) * 1000;
    if (startMs >= endMs) return null;
    return { massId, period: { kind: 'custom', startMs, endMs } };
  }

  const kind = periodText === '' ? 'same' : periodText;
  if (!RELATIVE_KINDS.includes(kind)) return null;
  if (kind === 'same' && massId === null) return null;
  return { massId, period: { kind } };
}

export function decodeRights(search) {
  const raw = new URLSearchParams(search || '').get('vs');
  if (!raw) return [];
  // Entri cacat dibuang diam-diam, urutan sisanya dipertahankan.
  return raw.split(',').map(parseEntry).filter(Boolean).slice(0, MAX_COMPARISONS);
}

export function encodeRights(rights) {
  return (rights || []).map(encodeRight).filter((s) => s !== '').join(',');
}

export function rightsSearch(search, rights) {
  const query = new URLSearchParams(search || '');
  const encoded = encodeRights(rights);
  if (encoded) query.set('vs', encoded);
  else query.delete('vs');
  const out = query.toString();
  return out ? `?${out}` : '';
}
